import BodySwitcher from "./bodySwitcher";

const Tasks = () => {
  return (
    <div>
      <BodySwitcher />
    </div>
  );
};

export default Tasks;
